import { ForcePDFReader } from "../../files/ForcePDFReader"
import { GenerateFile } from "../../files/GenerateFile"
import { ConvertRectangle } from "../../geometry/ConvertRectangle"
import type { PdfEngine } from "../../types/engine/PdfEngine"
import { ContentType } from "../../types/files/ContentType"
import { VirtualFileType } from "../../types/files/VirtualFileType"
import type { TaskResult } from "../../types/tasks/input/TaskResult"
import type { TaskSplitOptions } from "../../types/tasks/options/TaskSplitOptions"
import { TaskName } from "../../types/tasks/TaskName"
import { TrackedTaskName } from "../../types/tasks/tracking/TrackedTaskName"
import type { TrackingCallback } from "../../types/tasks/tracking/TrackingCallback"

// options SplitPdfOptions file: GeneratedFile
// stream - no
// emit TrackingCallback
//
// return DocumentPage[1, GeneratedFile[...]]

export async function* TaskSplit(
  engine: PdfEngine,
  task: TaskSplitOptions,
  emit: TrackingCallback
): AsyncGenerator<TaskResult> {
  const doc = await ForcePDFReader(engine, task.options, task.source, emit)
  const page_count = await doc.page_count()

  void emit({
    name: TrackedTaskName.SPLIT_PDF,
    done: 0,
    total: page_count,
  })

  try {
    // Then yield each page as a separate PDF
    for (let page_number = 1; page_number <= page_count; page_number++) {
      const { stream, trim_box, media_box } =
        await doc.extract_page_as_pdf(page_number)

      const content = await GenerateFile(engine, stream, ContentType.PDF)

      yield {
        enum: TaskName.CONTENT_FILE,
        name: `${page_number}.pdf`,
        content: {
          enum: VirtualFileType.SINGLE_PAGE_PDF,
          content,
          source: task.source,
          page: undefined,
          context: undefined,
          file_meta: {},
          page_number,
          page_count,
          trim_box: ConvertRectangle(task.options, trim_box),
          media_box: ConvertRectangle(task.options, media_box),
        },
      }

      void emit({
        name: TrackedTaskName.SPLIT_PDF,
        done: page_number,
        total: page_count,
      })
    }
  } finally {
    await doc.close()
  }
}
